export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      title: true,
      name: 'Admin',
      class: '',
      wrapper: {
        element: 'span',
        attributes: {}
      }
    },
    {
      name: 'Accounts',
      url: '/accounts',
      icon: 'icon-list'
    },
    {
      title: true,
      name: 'Account Name',
      class: '',
      wrapper: {
        element: 'span',
        attributes: {}
      }
    },
    {
      name: 'Users',
      url: '/users',
      icon: 'icon-list'
    },
    {
      name: 'Products',
      url: '/products',
      icon: 'icon-list'
    },
    {
      name: 'Packages',
      url: '/packages',
      icon: 'icon-list'
    },
    {
      name: 'Coupons',
      url: '/coupons',
      icon: 'icon-list'
    },
    {
      name: 'Leads',
      url: '/leads',
      icon: 'icon-list'
    },
    {
      name: 'Orders',
      url: '/orders',
      icon: 'icon-list'
    },
    {
      name: 'Logout',
      url: '/logout',
      icon: 'icon-list'
    }

  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js